import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import axiosInstance from "../utils/axiosInstance";

function JoinChallengeModal(props) {
  const objectID = props.alldata._id;

  const requestData = {
    challenge_oid: objectID,
  };

  const joinChallenge = () => {
    axiosInstance
      .post("/challenges/participant", requestData)
      .then((response) => {
        props.onHide();
      })
      .catch((error) => {
        
      });
  };

  const watchChallenge = () => {
    axiosInstance
      .post("/challenges/spectator", requestData)
      .then(() => {
        props.onHide();
      })
      .catch(() => {});
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>Challenge Details</Modal.Header>
      <Modal.Body>
        <p>Join to complete daily activities, or watch to follow progress and join the conversation.</p>
        <h6>Details</h6>
        <p>Title: {props.alldata.title}</p>
        <p>Organizer: {props.alldata.organizer}</p>
        <p>Start Day: {props.alldata.start_date}</p>
        <Button variant="primary" onClick={joinChallenge}>
          Join challenge
        </Button>{" "}
        <Button variant="outline-primary" onClick={watchChallenge}>
          Watch only
        </Button>
      </Modal.Body>
    </Modal>
  );
}

export default JoinChallengeModal;
